import { useQuery } from 'apollo-3';

import { onlineCourseByCourseCode } from 'GraphQL/query/Product.query';

import { getStoreApolloClient } from '../../GraphQL';

const storeApolloClient = getStoreApolloClient();

const useOnlineCoursesData = ({ courseCode, ...options }) => {
  const { data, loading, error, refetch } = useQuery(onlineCourseByCourseCode, {
    variables: { courseCode },
    client: storeApolloClient,
    ...options,
  });

  return {
    data: data?.sfFoProductGetOnlineCourseByCourseCode,
    loading,
    error,
    refetch,
  };
};

export default useOnlineCoursesData;
